// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3EMzo","video":"styles_video__JhhYm","videoThumb":"styles_videoThumb__3j38g","tiny":"styles_tiny__Af-aW"};